import React from 'react';

/**
 * **쪽 넘기기** — [‹ 1 2 3 ›] 를 둥근 상자 하나에 묶고 지금 쪽만 보라로 채운다.
 *
 * 화면 안 탭·시뮬레이션 승패 단추와 같은 모양이다(사용자 2026-10-22 A안 — 예전 [이전] [1] [2] [다음] 은
 * 단추마다 테두리·보라 채움이 따로 있어 못생겼다). 끝 쪽에서는 그쪽 화살표를 흐리게 두고 누를 수 없다.
 *
 * `window` 를 주면 번호를 그만큼만 지금 쪽 둘레로 보인다(폰 — 좁아서 5개).
 */
export default function Pager({ page, total, onChange, compact = false, window: win }: {
    page: number;
    total: number;
    onChange: (page: number) => void;
    compact?: boolean;
    window?: number;
}) {
    if (total <= 1) return null;
    const size = compact ? 28 : 34;
    const count = win ? Math.min(total, win) : total;
    const start = win && total > win ? Math.min(Math.max(1, page - Math.floor(win / 2)), total - win + 1) : 1;
    const pages = Array.from({ length: count }, (_, i) => start + i);

    const cell = (on: boolean, disabled = false): React.CSSProperties => ({
        minWidth: size, height: size, padding: 0, border: 'none', borderRadius: 9,
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        background: on ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'transparent',
        color: on ? '#fff' : '#8a8fa3',
        fontSize: compact ? 12 : 14, fontWeight: on ? 800 : 700,
        cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.35 : 1
    });
    const arrow = (dir: 'left' | 'right') => (
        <svg width={compact ? 14 : 16} height={compact ? 14 : 16} viewBox="0 0 16 16" aria-hidden="true">
            <path d={dir === 'left' ? 'M10 3 L5 8 L10 13' : 'M6 3 L11 8 L6 13'} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    return (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: compact ? 16 : 28 }}>
            <div style={{
                display: 'inline-flex', gap: 3, padding: 3, borderRadius: 12,
                border: '1.5px solid rgba(102, 126, 234, 0.3)', background: 'rgba(102, 126, 234, 0.06)'
            }}>
                <button type="button" aria-label="이전 쪽" disabled={page <= 1} onClick={() => onChange(Math.max(1, page - 1))} style={cell(false, page <= 1)}>
                    {arrow('left')}
                </button>
                {pages.map((n) => (
                    <button key={n} type="button" onClick={() => onChange(n)} style={cell(n === page)}>{n}</button>
                ))}
                <button type="button" aria-label="다음 쪽" disabled={page >= total} onClick={() => onChange(Math.min(total, page + 1))} style={cell(false, page >= total)}>
                    {arrow('right')}
                </button>
            </div>
        </div>
    );
}
